import { createReducer } from "../../util/reducerUtil";
import {
    FETCH_DATA,
    FETCH_CLOUD_DATA,
    UPDATE_TEST_ATTENDEE
} from "./testPageConstants";

const initialState = {};

export const fetchData = (state, payload) => {
    return payload.data;
};

export const fetchCloudData = (state, payload) => {
    return payload;
};

export const updateTestAttendee = (state, payload) => {
    return payload;
};

export default createReducer(initialState, {
    [FETCH_DATA]: fetchData,
    [FETCH_CLOUD_DATA]: fetchCloudData,
    [UPDATE_TEST_ATTENDEE]: updateTestAttendee
});
